import news1Header from "./news/1/круглый-стол-2048x1365.jpg";
import news2Header from "./news/2/встреча-1.jpg";
import news3Header from "./news/3/Собрание-ННС.jpg";
import news4Header from "./news/4/7.jpg";
import news4_1 from "./news/4/8.jpg";
import news4_2 from "./news/4/9-768x1024.jpg";
import news5Header from "./news/5/данныеъ.jpg";
import news5_1 from "./news/5/видос-1.mp4";
import news6Header from "./news/6/3.jpg";
import news6_1 from "./news/6/1-1024x768.jpg";
import news6_2 from "./news/6/2.jpg";
import news6_3 from "./news/6/3 (1).jpg";
import news6_4 from "./news/6/4.jpg";
import news6_5 from "./news/6/5.jpg";
import news6_6 from "./news/6/6-768x1024.jpg";
import news7Header from "./news/7/DSC08968-2048x1365.jpg";
import news7_1 from "./news/7/DSC09008-1024x683.jpg";
import news8_1 from "./news/8/image_2025-05-21_20-21-28-576x1024.png";
import news8_2 from "./news/8/image_2025-05-21_20-21-44-575x1024.png";
import news9Header from "./news/9/photo_5393451464975841457_w.jpg";



export const newsData = [
  {
    id: 9,
    title: {
      ru: "Выступление команды AQUAGUARD на презентации интеллектуального решения для мониторинга водных ресурсов",
      kk: "AQUAGUARD командасының су ресурстарын мониторингтеуге арналған зияткерлік шешімнің таныстырылымындағы баяндамасы",
      en: "The AQUAGUARD team's presentation of an intelligent solution for water resources monitoring"
    },
    headerImage: news9Header,
    date: "2025-10-09",
    excerpt: {
      ru: "В рамках проекта BR24993128 команда AQUAGUARD представила интеллектуальное решение для выявления нелегального использования водных ресурсов с использованием методов искусственного интеллекта и аэрокосмических снимков",
      kk: "BR24993128 жобасы аясында AQUAGUARD командасы жасанды интеллект әдістері мен аэроғарыштық суреттерді пайдалана отырып, су ресурстарын заңсыз пайдалануды анықтауға арналған зияткерлік шешімді ұсынды",
      en: "As part of the BR24993128 project, the AQUAGUARD team presented an intelligent solution for detecting illegal use of water resources using artificial intelligence methods and aerospace imagery"
    },
    content: [
      {
        type: "text",
        data: {
          ru: "В рамках проекта BR24993128 «Разработка информационно-аналитической системы для эффективного использования трансграничных водных ресурсов в сельскохозяйственном секторе Жамбылской области» состоялось выступление команды AQUAGUARD, в ходе которого было представлено интеллектуальное решение для выявления нелегального использования водных ресурсов с использованием методов искусственного интеллекта и аэрокосмических снимков.",
          kk: "BR24993128 «Жамбыл облысының ауыл шаруашылығы секторында трансшекаралық су ресурстарын тиімді пайдалануға арналған ақпараттық-талдау жүйесін әзірлеу» жобасы аясында AQUAGUARD командасының баяндамасы өтті, оның барысында жасанды интеллект әдістері мен аэроғарыштық суреттерді пайдалана отырып, су ресурстарын заңсыз пайдалануды анықтауға арналған зияткерлік шешім таныстырылды.",
          en: "As part of the BR24993128 project «Development of an information and analytical system for the effective use of transboundary water resources in the agricultural sector of Zhambyl region», the AQUAGUARD team gave a presentation in which an intelligent solution for detecting illegal use of water resources using artificial intelligence methods and aerospace imagery was presented."
        }
      },
      {
        type: "text",
        data: {
          ru: "Система обеспечивает мониторинг водных объектов, оперативное обнаружение несанкционированного водозабора и помогает рационально распределять водные ресурсы, что напрямую способствует усилению водной и продовольственной безопасности региона.\n",
          kk: "Жүйе су объектілерін мониторингтеуді, рұқсатсыз су алуды жедел анықтауды қамтамасыз етеді және су ресурстарын ұтымды бөлуге көмектеседі, бұл өңірдің су және азық-түлік қауіпсіздігін нығайтуға тікелей ықпал етеді.\n",
          en: "The system provides monitoring of water bodies, prompt detection of unauthorized water withdrawal and helps to distribute water resources rationally, which directly contributes to strengthening the region's water and food security.\n"
        }
      },
      {
        type: "text",
        data: {
          ru: "Выступление команды вызвало активный интерес у представителей государственных органов, научного сообщества и бизнеса. Особенно отметили актуальность и практическую значимость проекта члены жюри конкурса AI SANA Generative Nation, в состав которого вошли:\n",
          kk: "Команданың баяндамасы мемлекеттік органдар, ғылыми қоғамдастық және бизнес өкілдерінің белсенді қызығушылығын тудырды. Жобаның өзектілігі мен практикалық маңыздылығын AI SANA Generative Nation байқауының қазылар алқасының мүшелері ерекше атап өтті, оның құрамына кірді:\n",
          en: "The team's presentation aroused active interest among representatives of government agencies, the scientific community and business. The relevance and practical significance of the project were especially noted by the jury members of the AI SANA Generative Nation competition, which included:\n"
        }
      },
      {
        type: "text",
        data: {
          ru: "Екатерина Смышляева, депутат Мажилиса Парламента РК;\n",
          kk: "Екатерина Смышляева, ҚР Парламенті Мәжілісінің депутаты;\n",
          en: "Yekaterina Smyshlyayeva, deputy of the Mazhilis of the Parliament of the Republic of Kazakhstan;\n"
        }
      },
      {
        type: "text",
        data: {
          ru: "Берик Ахметов, руководитель управления цифровизации и государственных услуг города Астаны;\n",
          kk: "Берік Ахметов, Астана қаласының цифрландыру және мемлекеттік қызметтер басқармасының басшысы;\n",
          en: "Berik Akhmetov, head of the digitalization and public services department of the city of Astana;\n"
        }
      },
      {
        type: "text",
        data: {
          ru: "Алибек Датбаев, Technology Leader компании Booking.com;\n",
          kk: "Әлібек Датбаев, Booking.com компаниясының Technology Leader қызметкері;\n",
          en: "Alibek Datbayev, Technology Leader at Booking.com;\n"
        }
      },
      {
        type: "text",
        data: {
          ru: "Гульмира Шарбакова, менеджер по архитектуре цифровых решений TengizChevroil;\n",
          kk: "Гүлмира Шарбакова, TengizChevroil цифрлық шешімдер архитектурасы жөніндегі менеджер;\n",
          en: "Gulmira Sharbakova, digital solutions architecture manager at TengizChevroil;\n"
        }
      },
      {
        type: "text",
        data: {
          ru: "Арай Бекембаев, Country Business Manager inDrive;\n",
          kk: "Арай Бекембаев, inDrive компаниясының Country Business Manager қызметкері;\n",
          en: "Aray Bekembayev, Country Business Manager at inDrive;\n"
        }
      },
      {
        type: "text",
        data: {
          ru: "Айдана Каскырбек, генеральный директор Blockchain & AI Technology Center;\n",
          kk: "Айдана Қасқырбек, Blockchain & AI Technology Center бас директоры;\n",
          en: "Aidana Kaskyrbek, CEO of the Blockchain & AI Technology Center;\n"
        }
      },
      {
        type: "text",
        data: {
          ru: "Адина Магавина, генеральный директор Alem.ai Foundation \n" +
              "Astana Hub\n",
          kk: "Адина Магавина, Alem.ai Foundation бас директоры \n" +
              "Astana Hub\n",
          en: "Adina Magavina, CEO of the Alem.ai Foundation \n" +
              "Astana Hub\n"
        }
      },
      {
        type: "text",
        data: {
          ru: "Жюри высоко оценило потенциал масштабирования проекта AQUAGUARD и его вклад в устойчивое развитие региональных водных систем.",
          kk: "Қазылар алқасы AQUAGUARD жобасының ауқымдану әлеуетін және оның өңірлік су жүйелерінің тұрақты дамуына қосқан үлесін жоғары бағалады.",
          en: "The jury highly appreciated the scaling potential of the AQUAGUARD project and its contribution to the sustainable development of regional water systems."
        }
      },
      {
        type: "text",
        data: {
          ru: "",
          kk: "",
          en: ""
        }
      },
    ]
  },
  {
    id: 8,
    title: {
      ru: "Установка датчиков и электронного оборудования в Жамбылской области",
      kk: "Жамбыл облысында датчиктер мен электронды жабдықты орнату",
      en: "Installation of sensors and electronic equipment in the Zhambyl region"
    },
    headerImage: null, // Используем placeholder
    date: "2025-05-20",
    excerpt: {
      ru: "На днях в одном из каналов региона была произведена установка специализированных датчиков и электронного оборудования для мониторинга водных ресурсов",
      kk: "Жуырда өңірдің бір каналында су ресурстарын мониторингтеуге арналған мамандандырылған датчиктер мен электронды жабдық орнатылды",
      en: "Recently, specialized sensors and electronic equipment for water resources monitoring were installed in one of the region's canals"
    },
    content: [
      {
        type: "text",
        data: {
          ru: "На днях в одном из каналов региона была произведена установка:",
          kk: "Жуырда өңірдің бір каналында мыналар орнатылды:",
          en: "Recently, the following were installed in one of the region's canals:"
        }
      },
      {
        type: "text",
        data: {
          ru: "• специализированных датчиков уровня и потока воды;",
          kk: "• су деңгейі мен ағынының мамандандырылған датчиктері;",
          en: "• specialized water level and flow sensors;"
        }
      },
      {
        type: "text",
        data: {
          ru: "• электронного модуля в защитном ящике, включающего контроллер, блок связи а так же блок питания для автономной работы;",
          kk: "• автономды жұмыс істеуге арналған контроллерді, байланыс блогын, сондай-ақ қуат блогын қамтитын қорғаныш жәшіктегі электронды модуль;",
          en: "• an electronic module in a protective box, including a controller, a communication unit and a power supply unit for autonomous operation;"
        }
      },
      {
        type: "text",
        data: {
          ru: "• соединительных элементов и источников питания, адаптированных под местные климатические и эксплуатационные условия.",
          kk: "• жергілікті климаттық және пайдалану жағдайларына бейімделген жалғағыш элементтер мен қуат көздері.",
          en: "• connecting elements and power sources adapted to local climatic and operational conditions."
        }
      },
      {
        type: "image",
        data: news8_1,
      },
      {
        type: "image",
        data: news8_2,
      },
    ]
  },
  {
    id: 7,
    title: {
      ru: "Круглый стол по цифровизации водоучета в Жамбылском регионе прошёл на базе Astana IT University",
      kk: "Жамбыл өңірінде су есебін цифрландыру бойынша дөңгелек үстел Astana IT University базасында өтті",
      en: "A round table on the digitalization of water accounting in the Zhambyl region was held at Astana IT University"
    },
    headerImage: news7Header,
    date: "2025-05-20",
    excerpt: {
      ru: "19 мая 2025 года на базе Astana IT University состоялся круглый стол на тему «Цифровизация водоучета Жамбылского региона в современных условиях на естественных протоках, водоемах и гидротехнических сооружениях»",
      kk: "2025 жылғы 19 мамырда Astana IT University базасында «Жамбыл өңірінің су есебін табиғи арналарда, су айдындарында және гидротехникалық құрылыстарда қазіргі жағдайда цифрландыру» тақырыбында дөңгелек үстел өтті",
      en: "On May 19, 2025, a round table on the topic «Digitalization of water accounting in the Zhambyl region under modern conditions on natural watercourses, water bodies and hydraulic structures» was held at Astana IT University"
    },
    content: [
      {
        type: "text",
        data: {
          ru: "19 мая 2025 года на базе Astana IT University состоялся круглый стол на тему «Цифровизация водоучета Жамбылского региона в современных условиях на естественных протоках, водоемах и гидротехнических сооружениях»",
          kk: "2025 жылғы 19 мамырда Astana IT University базасында «Жамбыл өңірінің су есебін табиғи арналарда, су айдындарында және гидротехникалық құрылыстарда қазіргі жағдайда цифрландыру» тақырыбында дөңгелек үстел өтті",
          en: "On May 19, 2025, a round table on the topic «Digitalization of water accounting in the Zhambyl region under modern conditions on natural watercourses, water bodies and hydraulic structures» was held at Astana IT University"
        }
      },
      {
        type: "text",
        data: {
          ru: "Цель мероприятия — подведение промежуточных итогов проделанной работы, обмен опытом между заинтересованными сторонами и определение ключевых направлений дальнейшего развития проекта.",
          kk: "Іс-шараның мақсаты — атқарылған жұмыстың аралық қорытындысын шығару, мүдделі тараптар арасында тәжірибе алмасу және жобаның одан әрі дамуының негізгі бағыттарын айқындау.",
          en: "The aim of the event was to summarize the interim results of the work done, exchange experience between stakeholders and identify key directions for the project's further development."
        }
      },
      {
        type: "text",
        data: {
          ru: "В работе круглого стола приняли участие представители:",
          kk: "Дөңгелек үстел жұмысына мына ұйымдардың өкілдері қатысты:",
          en: "Representatives of the following organizations took part in the round table:"
        }
      },
      {
        type: "text",
        data: {
          ru: "• РГП «Казводхоз», включая Бакбергенова А. — начальника отдела диспетчеризации, энергетики и автоматизации Жамбылского филиала",
          kk: "• «Казводхоз» РМК, оның ішінде Жамбыл филиалының диспетчерлеу, энергетика және автоматтандыру бөлімінің бастығы Бакбергенов А.",
          en: "• RSE «Kazvodkhoz», including A. Bakbergenov — head of the dispatching, energy and automation department of the Zhambyl branch"
        }
      },
      {
        type: "text",
        data: {
          ru: "• Цифрового департамента «Казсушар», представленного ведущим экспертом Ж. Абдибаевым",
          kk: "• «Казсушар» цифрлық департаменті, оны жетекші сарапшы Ж. Әбдібаев таныстырды",
          en: "• The Digital Department of «Kazsushar», represented by leading expert Zh. Abdibayev"
        }
      },
      {
        type: "text",
        data: {
          ru: "• Министерства водных ресурсов и ирригации Республики Казахстана",
          kk: "• Қазақстан Республикасының Су ресурстары және ирригация министрлігі",
          en: "• The Ministry of Water Resources and Irrigation of the Republic of Kazakhstan"
        }
      },
      {
        type: "text",
        data: {
          ru: "• ведущих IT-компаний, занимающихся разработкой решений в области цифровизации водного хозяйства",
          kk: "• су шаруашылығын цифрландыру саласында шешімдер әзірлеумен айналысатын жетекші IT-компаниялар",
          en: "• leading IT companies engaged in developing solutions in the field of water management digitalization"
        }
      },
      {
        type: "text",
        data: {
          ru: "• представители научного сообщества, преподаватели и исследователи Astana IT University",
          kk: "• ғылыми қоғамдастық өкілдері, Astana IT University оқытушылары мен зерттеушілері",
          en: "• representatives of the scientific community, lecturers and researchers of Astana IT University"
        }
      },
      {
        type: "text",
        data: {
          ru: "Участники обсудили современные вызовы в области учёта водных ресурсов на трансграничных водоёмах и каналах, вопросы автоматизации и мониторинга, внедрение IoT-технологий и информационно-аналитических платформ. Особое внимание было уделено практике сбора и обработки данных в условиях сельскохозяйственного водопользования.",
          kk: "Қатысушылар трансшекаралық су айдындары мен каналдарда су ресурстарын есепке алу саласындағы заманауи сын-қатерлерді, автоматтандыру мен мониторинг мәселелерін, IoT-технологиялар мен ақпараттық-талдау платформаларын енгізуді талқылады. Ауыл шаруашылығында суды пайдалану жағдайында деректерді жинау және өңдеу тәжірибесіне ерекше назар аударылды.",
          en: "The participants discussed modern challenges in accounting for water resources on transboundary water bodies and canals, issues of automation and monitoring, and the implementation of IoT technologies and information and analytical platforms. Particular attention was paid to the practice of data collection and processing under conditions of agricultural water use."
        }
      },
      {
        type: "text",
        data: {
          ru: "Также прозвучали доклады о текущих результатах проекта: были представлены прототипы систем мониторинга, аналитические панели и перспективы масштабирования решений на другие регионы страны.",
          kk: "Сондай-ақ жобаның ағымдағы нәтижелері туралы баяндамалар жасалды: мониторинг жүйелерінің прототиптері, талдау панельдері және шешімдерді елдің басқа өңірлеріне ауқымдау перспективалары ұсынылды.",
          en: "Reports on the current results of the project were also presented: prototypes of monitoring systems, analytical dashboards and prospects for scaling the solutions to other regions of the country were demonstrated."
        }
      },
      {
        type: "text",
        data: {
          ru: "Astana IT University выражает благодарность всем участникам круглого стола за активное участие и конструктивный диалог. Совместная работа учёных, ИТ-специалистов и представителей водного сектора открывает новые горизонты для цифровой трансформации водного хозяйства Казахстана.",
          kk: "Astana IT University дөңгелек үстелдің барлық қатысушыларына белсенді қатысқаны және сындарлы диалог үшін алғыс білдіреді. Ғалымдардың, IT-мамандардың және су секторы өкілдерінің бірлескен жұмысы Қазақстанның су шаруашылығын цифрлық трансформациялау үшін жаңа көкжиектер ашады.",
          en: "Astana IT University expresses its gratitude to all participants of the round table for their active participation and constructive dialogue. The joint work of scientists, IT specialists and representatives of the water sector opens new horizons for the digital transformation of Kazakhstan's water management."
        }
      },
      {
        type: "image",
        data: news7_1,
      },
    ]
  },
  {
    id: 1,
    title: {
      ru: "Начало научного проекта: изучаем водные экосистемы",
      kk: "Ғылыми жобаның басталуы: су экожүйелерін зерттейміз",
      en: "The start of a scientific project: studying water ecosystems"
    },
    headerImage: news1Header,
    date: "2024-11-03",
    excerpt: {
      ru: "",
      kk: "",
      en: ""
    },
    content: [
      {
        type: "text",
        data: {
          ru: "Рады сообщить о старте нового научного проекта, направленного на исследование состояния и экологии рек! В рамках этого проекта уже проведен первый круглый стол, который состоялся в Международном Таразском Инновационном Институте им. Ш. Муртазы. На встрече собралась команда экспертов, включая зарубежных специалистов и представителей компаний, занимающихся разработкой систем экологического мониторинга и средств автоматизации. Обсуждались ключевые задачи и планы работ, нацеленные на создание современных подходов к сохранению и улучшению состояния водных ресурсов. Обмен опытом с международными коллегами и представителями ведущих компаний в области эко мониторинга позволяет нам использовать передовые технологии и методики в нашем проекте.",
          kk: "Өзендердің жай-күйі мен экологиясын зерттеуге бағытталған жаңа ғылыми жобаның басталуы туралы хабарлауға қуаныштымыз! Осы жоба аясында бірінші дөңгелек үстел өтті, ол Ш. Мұртаза атындағы Халықаралық Тараз Инновациялық Институтында өткізілді. Кездесуге шетелдік мамандарды және экологиялық мониторинг жүйелері мен автоматтандыру құралдарын әзірлеумен айналысатын компаниялар өкілдерін қоса алғанда, сарапшылар тобы жиналды. Су ресурстарының жай-күйін сақтау мен жақсартудың заманауи тәсілдерін жасауға бағытталған негізгі міндеттер мен жұмыс жоспарлары талқыланды. Халықаралық әріптестермен және эко мониторинг саласындағы жетекші компаниялар өкілдерімен тәжірибе алмасу бізге жобамызда озық технологиялар мен әдістемелерді пайдалануға мүмкіндік береді.",
          en: "We are pleased to announce the start of a new scientific project aimed at studying the condition and ecology of rivers! As part of this project, the first round table has already been held at the Sh. Murtaza International Taraz Innovation Institute. The meeting brought together a team of experts, including foreign specialists and representatives of companies engaged in developing environmental monitoring systems and automation tools. Key objectives and work plans aimed at creating modern approaches to preserving and improving the condition of water resources were discussed. The exchange of experience with international colleagues and representatives of leading companies in the field of eco-monitoring allows us to use advanced technologies and methodologies in our project."
        }
      },
      {
        type: "text",
        data: {
          ru: "На этой неделе наша команда также провела выездное обследование рек Жамбылского региона, включив в исследование несколько ключевых водоемов, представляющих интерес с точки зрения экологии и состояния их экосистем. Особое внимание было уделено проблемам трансграничных вод, которые требуют комплексного подхода и сотрудничества с соседними странами. Это важный этап для более глубокого понимания состояния водных экосистем и факторов, влияющих на их состояние.",
          kk: "Осы аптада біздің командамыз сондай-ақ Жамбыл өңірінің өзендерін көшпелі тексеру жүргізді, зерттеуге экология мен олардың экожүйелерінің жай-күйі тұрғысынан қызығушылық тудыратын бірнеше негізгі су айдындарын қосты. Кешенді тәсілді және көрші елдермен ынтымақтастықты талап ететін трансшекаралық сулар мәселелеріне ерекше назар аударылды. Бұл су экожүйелерінің жай-күйін және оларға әсер ететін факторларды тереңірек түсіну үшін маңызды кезең.",
          en: "This week, our team also conducted a field survey of the rivers of the Zhambyl region, including in the study several key water bodies of interest from the perspective of ecology and the condition of their ecosystems. Particular attention was paid to the problems of transboundary waters, which require a comprehensive approach and cooperation with neighboring countries. This is an important stage for a deeper understanding of the condition of water ecosystems and the factors affecting them."
        }
      },
      {
        type: "text",
        data: {
          ru: "Будем делиться с вами новостями и достижениями на каждом этапе нашего пути! Поддержите нас и следите за обновлениями, чтобы узнать больше о наших открытиях и рекомендациях.",
          kk: "Жолымыздың әр кезеңінде сіздермен жаңалықтар мен жетістіктерді бөлісіп отырамыз! Біздің ашқан жаңалықтарымыз бен ұсыныстарымыз туралы көбірек білу үшін бізді қолдап, жаңартуларды бақылап отырыңыздар.",
          en: "We will share news and achievements with you at every stage of our journey! Support us and follow the updates to learn more about our discoveries and recommendations."
        }
      },
    ]
  },
  {
    id: 2,
    title: {
      ru: "Проведена встреча с министерством водных ресурсов и ирригации",
      kk: "Су ресурстары және ирригация министрлігімен кездесу өтті",
      en: "A meeting with the Ministry of Water Resources and Irrigation was held"
    },
    headerImage: news2Header,
    date: "2024-12-09",
    excerpt: {
      ru: "",
      kk: "",
      en: ""
    },
  },
  {
    id: 3,
    title: {
      ru: "Доклад на ННС",
      kk: "ҰҒК-дегі баяндама",
      en: "Report at the National Scientific Council"
    },
    headerImage: news3Header,
    date: "2024-12-18",
    excerpt: {
      ru: "",
      kk: "",
      en: ""
    },
    content: [
      {
        type: "text",
        data: {
          ru: "18 декабря 2024 года на заседании Национального научного совета был рассмотрен промежуточный отчет по выполнению научно-исследовательской работы в рамках программно-целевого финансирования, а также результаты экспертизы ГНТЭ по промежуточному отчету. Коллеги поблагодарили за четкий и достаточно развернутый ответ. Такой интерес и ответственный подход со стороны ННС радует.",
          kk: "2024 жылғы 18 желтоқсанда Ұлттық ғылыми кеңестің отырысында бағдарламалық-нысаналы қаржыландыру аясында ғылыми-зерттеу жұмысын орындау бойынша аралық есеп, сондай-ақ аралық есеп бойынша МҒТС сараптамасының нәтижелері қаралды. Әріптестер нақты әрі жеткілікті түрде кеңейтілген жауап үшін алғыс білдірді. ҰҒК тарапынан мұндай қызығушылық пен жауапты көзқарас қуантады.",
          en: "On December 18, 2024, at a meeting of the National Scientific Council, the interim report on the implementation of research work within the framework of program-targeted financing was reviewed, as well as the results of the SSTE expert review of the interim report. Colleagues thanked us for the clear and sufficiently detailed response. Such interest and a responsible approach on the part of the National Scientific Council is gratifying."
        }
      },
    ]
  },
  {
    id: 4,
    title: {
      ru: "Проведена встреча с Жамбыльским филиалом РГП Казводхоз",
      kk: "«Казводхоз» РМК-нің Жамбыл филиалымен кездесу өтті",
      en: "A meeting with the Zhambyl branch of RSE Kazvodkhoz was held"
    },
    headerImage: news4Header,
    date: "2025-01-13",
    excerpt: {
      ru: "Было обсуждено согласование установки оборудования на гидропостах ГМК и Жасоркен",
      kk: "ГМК және Жасоркен гидропостыларында жабдықты орнатуды келісу талқыланды",
      en: "The approval of equipment installation at the GMK and Zhasorken hydrological posts was discussed"
    },
    content: [
      {
        type: "image",
        data: news4_1,
      },
      {
        type: "image",
        data: news4_2,
      },
    ]
  },
  {
    id: 5,
    title: {
      ru: "Было произведено подключение датчиков для измерения потоков к блоку управления",
      kk: "Ағындарды өлшеуге арналған датчиктер басқару блогына қосылды",
      en: "Sensors for measuring flows were connected to the control unit"
    },
    headerImage: news5Header,
    date: "2025-03-30",
    excerpt: {
      ru: "",
      kk: "",
      en: ""
    },
    content: [
      {
        type: "video",
        data: news5_1,
      },
    ]
  },
  {
    id: 6,
    title: {
      ru: "Обследование объектов для установки научно-исследовательского оборудования",
      kk: "Ғылыми-зерттеу жабдығын орнатуға арналған объектілерді тексеру",
      en: "Survey of sites for the installation of research equipment"
    },
    headerImage: news6Header,
    date: "2025-04-02",
    excerpt: {
      ru: "С 26 по 28 марта 2025 года в г. Кордай и вблизи населенного пункта Благовещенка (Жамбылская область) было осуществлено обследование двух объектов для установки научно-исследовательского оборудования для проведения замеров в рамках цифровизации водоучета воды на открытом канале на реке Чу и Георгиевском магистральном канале. Результатом стало согласование места установки оборудования и перечня подготовительных работ.",
      kk: "2025 жылғы 26-28 наурыз аралығында Қордай қаласында және Благовещенка елді мекеніне жақын жерде (Жамбыл облысы) Шу өзеніндегі ашық каналда және Георгиевск магистральдық каналында су есебін цифрландыру аясында өлшеулер жүргізуге арналған ғылыми-зерттеу жабдығын орнату үшін екі объект тексерілді. Нәтижесінде жабдықты орнату орны мен дайындық жұмыстарының тізбесі келісілді.",
      en: "From March 26 to 28, 2025, in the city of Kordai and near the settlement of Blagoveshchenka (Zhambyl region), a survey of two sites was carried out for the installation of research equipment to take measurements as part of the digitalization of water accounting on the open canal on the Chu River and the Georgievsky main canal. The result was the approval of the equipment installation location and the list of preparatory work."
    },
    content: [
      {
        type: "image",
        data: news6_1,
      },
      {
        type: "image",
        data: news6_2,
      },
      {
        type: "image",
        data: news6_3,
      },
      {
        type: "image",
        data: news6_4,
      },
      {
        type: "image",
        data: news6_5,
      },
      {
        type: "image",
        data: news6_6,
      },
    ]
  },
  // {
  //   id: 1,
  //   title: "Запуск нового проекта мониторинга качества воды",
  //   headerImage: null,
  //   date: "2024-01-15",
  //   excerpt: "Наша команда объявляет о запуске инновационного проекта по мониторингу качества воды в регионе.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "Сегодня мы рады объявить о запуске нашего нового проекта по мониторингу качества воды. Этот проект направлен на улучшение контроля за состоянием водных ресурсов в нашем регионе."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/water-monitoring-station.jpg",
  //       caption: "Современная станция мониторинга качества воды"
  //     },
  //     {
  //       type: "text",
  //       data: "Система включает в себя автоматизированные датчики, которые будут отслеживать различные параметры качества воды в режиме реального времени. Данные будут доступны для анализа через наш веб-интерфейс."
  //     },
  //     {
  //       type: "video",
  //       data: "/videos/project-overview.mp4",
  //       caption: "Обзор проекта мониторинга воды"
  //     }
  //   ]
  // },
  // {
  //   id: 2,
  //   title: "Новые технологии в анализе качества воды",
  //   headerImage: "/images/water-analysis.jpg",
  //   date: "2024-01-20",
  //   excerpt: "Внедрение современных методов анализа позволяет получать более точные данные о состоянии водных ресурсов.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "Наша лаборатория внедрила новейшие технологии анализа качества воды. Использование спектрометрии и хроматографии позволяет определять даже минимальные концентрации загрязняющих веществ."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/laboratory-equipment.jpg",
  //       caption: "Современное лабораторное оборудование"
  //     },
  //     {
  //       type: "text",
  //       data: "Эти технологии помогают нам предоставлять более точные и надежные результаты анализа, что критически важно для обеспечения безопасности питьевой воды."
  //     }
  //   ]
  // },
  // {
  //   id: 3,
  //   title: "Результаты исследования за первый квартал",
  //   headerImage: "/images/research-results.jpg",
  //   date: "2024-02-01",
  //   excerpt: "Представляем результаты комплексного исследования качества воды за первый квартал 2024 года.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "По итогам первого квартала 2024 года наша команда провела комплексное исследование качества воды в 15 точках мониторинга."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/research-chart.jpg",
  //       caption: "График изменения показателей качества воды"
  //     },
  //     {
  //       type: "text",
  //       data: "Результаты показывают стабильное соответствие большинства показателей установленным нормам. Однако выявлены несколько точек, требующих дополнительного внимания."
  //     },
  //     {
  //       type: "video",
  //       data: "/videos/quarterly-report.mp4",
  //       caption: "Видеоотчет о результатах исследования"
  //     },
  //     {
  //       type: "text",
  //       data: "Детальные данные доступны в разделе мониторинга нашего сайта. Мы продолжаем работу по улучшению качества водных ресурсов."
  //     }
  //   ]
  // },
  // {
  //   id: 4,
  //   title: "Партнерство с международными организациями",
  //   headerImage: "/images/partnership.jpg",
  //   date: "2024-02-10",
  //   excerpt: "Заключено соглашение о сотрудничестве с ведущими международными организациями в области экологии.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "Мы рады объявить о заключении стратегического партнерства с несколькими международными организациями, занимающимися вопросами экологии и качества воды."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/signing-ceremony.jpg",
  //       caption: "Церемония подписания соглашения о партнерстве"
  //     },
  //     {
  //       type: "text",
  //       data: "Это партнерство откроет новые возможности для обмена опытом, технологиями и лучшими практиками в области мониторинга качества воды."
  //     }
  //   ]
  // },
  // {
  //   id: 5,
  //   title: "Обучение местных специалистов",
  //   headerImage: "/images/training.jpg",
  //   date: "2024-02-15",
  //   excerpt: "Программа обучения местных специалистов по работе с системами мониторинга качества воды.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "Запущена комплексная программа обучения местных специалистов работе с современными системами мониторинга качества воды."
  //     },
  //     {
  //       type: "video",
  //       data: "/videos/training-program.mp4",
  //       caption: "Процесс обучения специалистов"
  //     },
  //     {
  //       type: "text",
  //       data: "Программа включает теоретические занятия и практические тренинги по использованию оборудования и интерпретации данных."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/training-session.jpg",
  //       caption: "Практическое занятие с оборудованием"
  //     }
  //   ]
  // }
];